import { SVGProps } from 'react'

export const TwoPeopleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='11'
      viewBox='0 0 16 11'
      fill='none'
      {...props}
    >
      <path
        d='M5.67541 2.49005C5.67541 3.29895 5.01966 3.9547 4.21075 3.9547C3.40184 3.9547 2.74609 3.29895 2.74609 2.49005C2.74609 1.68114 3.40184 1.02539 4.21075 1.02539C5.01966 1.02539 5.67541 1.68114 5.67541 2.49005Z'
        fill='currentColor'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.21117 1.57505C3.7056 1.57505 3.29576 1.9849 3.29576 2.49046C3.29576 2.99603 3.7056 3.40587 4.21117 3.40587C4.71673 3.40587 5.12658 2.99603 5.12658 2.49046C5.12658 1.9849 4.71673 1.57505 4.21117 1.57505ZM2.19727 2.49046C2.19727 1.37822 3.09892 0.476562 4.21117 0.476562C5.32342 0.476562 6.22507 1.37822 6.22507 2.49046C6.22507 3.60271 5.32342 4.50437 4.21117 4.50437C3.09892 4.50437 2.19727 3.60271 2.19727 2.49046Z'
        fill='currentColor'
      />
      <path
        d='M7.87211 9.81398H0.548828C0.548828 8.59344 1.28116 6.15234 4.21047 6.15234C7.13978 6.15234 7.87211 8.59344 7.87211 9.81398Z'
        fill='currentColor'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M0.835842 7.20495C1.48692 6.30068 2.56722 5.60352 4.21089 5.60352C5.85455 5.60352 6.93485 6.30068 7.58593 7.20495C8.21684 8.08121 8.42177 9.11624 8.42177 9.8144C8.42177 10.1177 8.17587 10.3636 7.87253 10.3636H0.549246C0.245906 10.3636 0 10.1177 0 9.8144C0 9.11624 0.204932 8.08121 0.835842 7.20495ZM1.14879 9.26516H7.27298C7.19463 8.81491 7.01779 8.29586 6.69447 7.8468C6.24705 7.22539 5.49653 6.70201 4.21089 6.70201C2.92524 6.70201 2.17472 7.22539 1.72731 7.8468C1.40398 8.29586 1.22714 8.81491 1.14879 9.26516Z'
        fill='currentColor'
      />
      <path
        d='M12.2672 2.49005C12.2672 3.29895 11.6115 3.9547 10.8025 3.9547C9.99364 3.9547 9.33789 3.29895 9.33789 2.49005C9.33789 1.68114 9.99364 1.02539 10.8025 1.02539C11.6115 1.02539 12.2672 1.68114 12.2672 2.49005Z'
        fill='currentColor'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M10.802 1.57505C10.2964 1.57505 9.88658 1.9849 9.88658 2.49046C9.88658 2.99603 10.2964 3.40587 10.802 3.40587C11.3076 3.40587 11.7174 2.99603 11.7174 2.49046C11.7174 1.9849 11.3076 1.57505 10.802 1.57505ZM8.78809 2.49046C8.78809 1.37822 9.68974 0.476562 10.802 0.476562C11.9142 0.476562 12.8159 1.37822 12.8159 2.49046C12.8159 3.60271 11.9142 4.50437 10.802 4.50437C9.68974 4.50437 8.78809 3.60271 8.78809 2.49046Z'
        fill='currentColor'
      />
      <path
        d='M15.4512 9.81398H10.2804C10.2804 6.88467 7.90762 6.15234 10.6916 6.15234C13.8734 6.15234 15.4512 8.59344 15.4512 9.81398Z'
        fill='currentColor'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M9.8045 5.64513C10.0408 5.61495 10.3356 5.60352 10.6911 5.60352C12.4329 5.60352 13.757 6.27514 14.645 7.13025C15.5103 7.96352 15.9998 9.01307 15.9998 9.8144C15.9998 10.1177 15.7539 10.3636 15.4506 10.3636H10.2799C9.97654 10.3636 9.73063 10.1177 9.73063 9.8144C9.73063 8.72526 9.37639 8.00557 9.09915 7.4423C9.04144 7.32506 8.98707 7.2146 8.93993 7.10899C8.8771 6.96826 8.79548 6.76791 8.78857 6.55694C8.78472 6.43935 8.80302 6.30377 8.86948 6.16904C8.93657 6.03304 9.03622 5.93137 9.14445 5.85811C9.34024 5.72558 9.58378 5.67332 9.8045 5.64513ZM10.8029 9.26516C10.6986 8.18321 10.308 7.40034 10.0684 6.92023C10.0338 6.8508 10.0023 6.78771 9.97528 6.73095C10.1404 6.71209 10.3715 6.70201 10.6911 6.70201C12.1311 6.70201 13.1867 7.25093 13.883 7.9215C14.3522 8.37331 14.6427 8.86296 14.7879 9.26516H10.8029Z'
        fill='currentColor'
      />
    </svg>
  )
}
